import AuthenticatedLayout from "@shared/layouts/AuthenticatedLayout";
import { useState } from "react";
import { CreateSpaceModal } from "../components/CreateSpaceModal";
import SpaceEntry from "../components/SpaceEntry";
import SpaceLeftContent from "../components/SpaceLeftContent";
import SpaceRightContent from "../components/SpaceRightContent";

function SpacePost() {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  return (
    <AuthenticatedLayout>
      <div className="px-4 sm:px-6 lg:px-8 py-8 md:py-0 w-full max-w-9xl mx-auto">
        <div className="xl:flex">
          {/* Left + Middle content */}
          <div className="md:flex flex-1">
            {/* Left content */}
            <SpaceLeftContent
              onCreateSpace={() => setIsCreateModalOpen(true)}
            />

            {/* Middle content */}
            <div className="flex-1 md:ml-8 xl:mx-4 2xl:mx-8">
              <div className="md:py-8">
                {/* Space entry */}
                <SpaceEntry />
              </div>
            </div>
          </div>

          {/* Right content */}
          <SpaceRightContent onCreateSpace={() => setIsCreateModalOpen(true)} />
        </div>
      </div>

      {/* Create Space Modal */}
      <CreateSpaceModal
        isOpen={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
      />
    </AuthenticatedLayout>
  );
}

export default SpacePost;
